var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"profile-tabs"},_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:tab.label,attrs:{"to":tab.href}},[_c('font-awesome-icon',{attrs:{"icon":tab.icon,"size":"2x"}}),_c('span',[_vm._v(_vm._s(tab.label))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }